export default {
  "hero.title": "USFans Spreadsheet — znajdź, porównaj i zbadaj zasoby USFans",
  "hero.subtitle": "Poznaj zasoby USFans Spreadsheet, praktyczne poradniki, informacje o sprzedawcach, porównania, informacje o wysyłce i wskazówki dotyczące bezpieczeństwa — wszystko w jednym, łatwym w obsłudze centrum zasobów.",
  "hero.support": "Szukasz jaśniejszego sposobu na badanie zasobów USFans? Zacznij od naszych uporządkowanych poradników USFans Spreadsheet, porównań i praktycznych narzędzi badawczych.",
  "hero.ctaPrimary": "Poznaj USFans Spreadsheet",
  "hero.ctaSecondary": "Zacznij od poradnika dla początkujących",
  "hero.badge": "Niezależne centrum zasobów",

  "trust.1": "Niezależne zasoby",
  "trust.2": "Aktualizowane poradniki",
  "trust.3": "Treści wielojęzyczne",
  "trust.4": "Badania skoncentrowane na bezpieczeństwie",

  "jump.title": "Odwiedź nasz sklep",
  "jump.subtitle": "Gotowy, aby przejrzeć pełną ofertę? Przejdź bezpośrednio do oficjalnego sklepu.",
  "jump.primary": "USFans Spreadsheet",
  "jump.secondary": "Kup teraz",

  "whatIs.title": "Czym jest USFans Spreadsheet?",
  "whatIs.text": "USFans Spreadsheet jest powszechnie używany do porządkowania i badania informacji o produktach, sprzedawcach i zakupach. Nasze centrum zasobów pomaga początkującym i doświadczonym użytkownikom zrozumieć informacje z arkusza, porównać opcje, ocenić ważne szczegóły i prowadzić dokładniejsze badania.",
  "whatIs.cta": "Poznaj poradnik USFans Spreadsheet",

  "research.title": "Wszystko, czego potrzebujesz, aby badać USFans",
  "research.subtitle": "Uporządkowany zestaw zasobów obejmujących najważniejsze aspekty badania USFans.",
  "research.spreadsheet.title": "USFans Spreadsheet",
  "research.spreadsheet.text": "Poznaj główne zasoby arkusza i naucz się, jak czytać i badać informacje.",
  "research.review.title": "Opinie o USFans",
  "research.review.text": "Zrozum, co sprawdzać podczas badania opinii, reputacji i doświadczeń użytkowników USFans.",
  "research.shipping.title": "Koszt wysyłki USFans",
  "research.shipping.text": "Dowiedz się, jakie czynniki mogą wpływać na koszty wysyłki i jakie informacje porównywać.",
  "research.warehouse.title": "Magazyn USFans",
  "research.warehouse.text": "Zrozum informacje o magazynie, pojęcia dotyczące przechowywania i częste pytania.",
  "research.coupon.title": "Kupon USFans",
  "research.coupon.text": "Dowiedz się, jak badać kupony, promocje i informacje o rabatach USFans.",
  "research.safety.title": "Bezpieczeństwo USFans",
  "research.safety.text": "Zidentyfikuj typowe zagrożenia, podejrzane twierdzenia i ważne kwestie bezpieczeństwa.",

  "compare.title": "Porównaj zasoby USFans, zanim podejmiesz decyzję",
  "compare.text": "Różne zasoby mogą dostarczać różne poziomy informacji. Skorzystaj z naszych poradników porównawczych, aby ocenić kategorie, dostępne informacje, szczegóły kontroli jakości, informacje o wysyłce i potencjalne ograniczenia przed podjęciem decyzji.",
  "compare.cta": "Zobacz porównania USFans",

  "beginner.title": "Nowy w USFans? Zacznij tutaj.",
  "beginner.subtitle": "Prosta trzyetapowa ścieżka do pewniejszego badania.",
  "beginner.step1.title": "Znajdź",
  "beginner.step1.text": "Odkryj odpowiednie zasoby USFans Spreadsheet.",
  "beginner.step2.title": "Porównaj",
  "beginner.step2.text": "Porównaj dostępne informacje i zrozum różnice.",
  "beginner.step3.title": "Zbadaj",
  "beginner.step3.text": "Przejrzyj bezpieczeństwo, wysyłkę, magazyn i inne ważne szczegóły.",
  "beginner.cta": "Przeczytaj pełny poradnik dla początkujących",

  "guides.title": "Poradniki USFans: opinie, wysyłka, magazyn i rabaty",
  "guides.subtitle": "Dedykowane zasoby na najczęściej wyszukiwane tematy.",
  "guides.review.title": "Opinie o USFans",
  "guides.review.text": "Co sprawdzić, zanim zaufasz opinii.",
  "guides.shipping.title": "Koszt wysyłki USFans",
  "guides.shipping.text": "Czynniki wpływające na opłaty za wysyłkę.",
  "guides.coupon.title": "Kupon USFans",
  "guides.coupon.text": "Jak badać promocje.",
  "guides.discount.title": "Kod rabatowy USFans",
  "guides.discount.text": "Co sprawdzić przed użyciem.",
  "guides.warehouse.title": "Magazyn USFans",
  "guides.warehouse.text": "Pojęcia dotyczące przechowywania i częste pytania.",
  "guides.legit.title": "Czy USFans jest legalny",
  "guides.legit.text": "Sygnały legalności i ostrożności.",

  "category.title": "Przeglądaj produkty według kategorii",
  "category.subtitle": "Przejdź bezpośrednio do dowolnej kategorii produktów w sklepie.",
  "category.dropdownLabel": "Wybierz kategorię",
  "category.all": "Wszystkie kategorie",

  "article.title": "Najnowsze poradniki USFans Spreadsheet",
  "article.subtitle": "Świeże, oryginalne poradniki, które pomogą Ci prowadzić badania z pewnością.",

  "safety.title": "Centrum bezpieczeństwa USFans Spreadsheet",
  "safety.text": "Badanie zakupów online wymaga starannej weryfikacji. Nasze centrum bezpieczeństwa wyjaśnia, jak identyfikować podejrzane informacje, oceniać twierdzenia, chronić dane osobowe i weryfikować ważne szczegóły przed podjęciem działań.",
  "safety.cta": "Przeczytaj poradnik bezpieczeństwa",

  "faq.title": "Często zadawane pytania",
  "faq.q1": "Czym jest USFans Spreadsheet?",
  "faq.a1": "USFans Spreadsheet to sposób na porządkowanie i badanie informacji o produktach, sprzedawcach i zakupach w jednym miejscu, co ułatwia porównywanie opcji i ocenę szczegółów.",
  "faq.q2": "Jak działa USFans Spreadsheet?",
  "faq.a2": "Porządkuje ustrukturyzowane informacje, takie jak produkty, sprzedawcy, ceny i szczegóły wysyłki, w kolumny i wiersze, dzięki czemu możesz szybciej przeglądać i porównywać dane.",
  "faq.q3": "Jak czytać USFans Spreadsheet?",
  "faq.a3": "Zacznij od nagłówków kolumn, a następnie śledź każdy wiersz, aby zrozumieć dane dotyczące konkretnego produktu lub sprzedawcy. Sprawdź kluczowe kolumny, takie jak nazwa, cena, kontrola jakości i wysyłka.",
  "faq.q4": "Czy USFans jest legalny?",
  "faq.a4": "Legalność zależy od źródła, które sprawdzasz. Zawsze weryfikuj informacje, szukaj wiarygodnych szczegółów i zachowaj ostrożność wobec twierdzeń, które wydają się zbyt dobre, aby były prawdziwe.",
  "faq.q5": "Ile kosztuje wysyłka USFans?",
  "faq.a5": "Koszty wysyłki różnią się w zależności od miejsca docelowego, wagi, przewoźnika i innych czynników. Porównaj wiele źródeł i potwierdź ostateczny koszt przed zakupem.",
  "faq.q6": "Czy USFans ma kupony?",
  "faq.a6": "Promocje i kupony mogą pojawiać się z czasem. Zweryfikuj każdy kupon lub kod rabatowy bezpośrednio i uważaj na nieoficjalne lub nieweryfikowalne oferty.",
  "faq.q7": "Gdzie jest magazyn USFans?",
  "faq.a7": "Szczegóły magazynu mogą się zmieniać. Sprawdź oficjalne lub aktualne źródła, aby uzyskać najdokładniejsze informacje o lokalizacji i przechowywaniu.",
  "faq.q8": "Jak zweryfikować informacje o USFans?",
  "faq.a8": "Porównaj wiele niezależnych źródeł, szukaj dat i aktualizacji oraz potwierdź kluczowe szczegóły bezpośrednio przed podjęciem decyzji.",

  "final.title": "Gotowy, aby poznać USFans Spreadsheet?",
  "final.text": "Zacznij od poradnika USFans Spreadsheet, porównaj odpowiednie zasoby i naucz się badać ważne informacje z większą pewnością.",
  "final.ctaPrimary": "Poznaj USFans Spreadsheet",
  "final.ctaSecondary": "Przeglądaj wszystkie poradniki"
};